export default {
  BASE_API_URL: 'https://wizualizacje.metropoliagzm.pl',
  // BASE_API_URL: 'https://wizualizacje.metropoliagzm.pl',
  // BASE_API_URL: "https://gzm-visualizer-ui-gzm.apps.kubercluster.opendata.local",
  DATASET_URL: "/api/datasets",
};
